import React, { useState, useEffect } from 'react';
import DahaFazlaGor from '../components/DahaFazlaGor';

export default function Baglantılar() {
  const [kaynaklar, setKaynaklar] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredKaynaklar, setFilteredKaynaklar] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedType, setSelectedType] = useState('all');
  const itemsPerPage = 10;
  const [error, setError] = useState(null);




  useEffect(() => {
    fetch('/Kaynaklar.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        if (data.length === 0) {
          setError('Yapım Aşamasında...');
        } else {
          setKaynaklar(data);
          setFilteredKaynaklar(data);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setError('Veriler yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
      });
  }, []);

  const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    filterData(value, selectedType);
  };

  const handleTypeChange = (event) => {
    const value = event.target.value;
    setSelectedType(value);
    filterData(searchTerm, value);
  };

  const filterData = (searchTerm, type) => {
    let filtered = kaynaklar;

    if (searchTerm) {
      filtered = filtered.filter((kaynak) =>
        kaynak.title.toLowerCase().includes(searchTerm)
      );
    }

    if (type !== 'all') {
      filtered = filtered.filter((kaynak) => kaynak.type === type);
    }

    setFilteredKaynaklar(filtered);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredKaynaklar.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredKaynaklar.length / itemsPerPage);

  return (
    <div className="container mx-auto px-4 py-20 bg-gray-50">
      <h1 className="text-2xl sm:text-4xl font-bold text-blue-900 mb-8 text-center">Bağlantılar</h1>

      <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md mb-8">
        <h2 className="text-xl sm:text-2xl font-semibold text-blue-800 mb-4">Filtreleme ve Arama</h2>

        <label className="block text-gray-700 mb-2 font-medium" htmlFor="filter">
          Kaynak Türü
        </label>
        <select
          id="filter"
          value={selectedType}
          onChange={handleTypeChange}
          className="border border-gray-300 rounded p-2 mb-4 w-full"
        >
          <option value="all">Hepsi</option>
          <option value="website">Web Sitesi</option>
          <option value="video">Video</option>
          <option value="book">Kitap</option>
          <option value="Makale">Makale</option>
          <option value="other">Diğerleri</option>
        </select>

        <div className="flex flex-col sm:flex-row items-center">
          <input
            type="text"
            placeholder="Kaynakça ara..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="border border-gray-300 rounded p-2 w-full sm:mr-2 mb-2 sm:mb-0"
          />
          <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition w-full sm:w-auto">
            Ara
          </button>
        </div>
      </div>

      <div className="space-y-6">
        {currentItems.map((kaynak, index) => (
          <div
            key={index}
            className="bg-white p-4 sm:p-6 rounded-lg shadow-md border border-gray-200"
          >
            {/* Layout based on kaynak type */}
            {kaynak.type === 'website' ? (
              <div className="flex flex-col items-start p-4 max-h-48 overflow-y-auto w-full pt-2 space-y-1">
                <div className="flex items-center mb-2">
                  <img
                    src={kaynak.image}
                    alt="Website icon"
                    className="w-8 h-8 mr-2"
                  />
                  <h3 className="text-lg font-semibold text-blue-900 ">
                    {kaynak.title}
                  </h3>
                </div>
                {/* List of links with consistent padding */}
                <div className="max-h-40 overflow-y-auto w-full pt-2 space-y-1">
                  <a
                    href={kaynak.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block text-blue-600 hover:text-blue-800 transition text-sm p-2 bg-gray-50 rounded break-words"
                    style={{
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                      padding: '8px',
                    }}
                  >
                    {kaynak.link}
                  </a>
                </div>
              </div>
            ) : kaynak.type === 'video' ? (
              <div className="flex flex-col sm:flex-row items-start bg-gray-100 p-4 sm:p-6 rounded-lg shadow-md border border-gray-200">
                {/* Video Thumbnail Sol Alanda */}
                <div className="relative w-32 h-20 flex-shrink-0 mr-4">
                  <img
                    src={`https://img.youtube.com/vi/${kaynak.link.split('v=')[1]}/0.jpg`} // YouTube Thumbnail
                    alt="Video Thumbnail"
                    className="absolute inset-0 w-full h-full object-cover rounded"
                  />
                  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded">
                    {/* Play Button */}
                    <svg
                      className="w-8 h-8 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 3l14 9-14 9V3z"
                      />
                    </svg>
                  </div>
                </div>

                {/* Sağdaki Metin Alanı */}
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-blue-900">
                    {kaynak.title}
                  </h3>

                  {/* DahaFazlaGor Bileşeni ile Açıklama */}
                  <DahaFazlaGor text={kaynak.description} wordLimit={50} />

                  <a
                    href={kaynak.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-blue-600 text-white font-medium text-sm px-4 py-2 rounded-lg shadow-md hover:bg-blue-700 hover:shadow-lg focus:ring-2 focus:ring-blue-500 focus:outline-none transition-all"
                  >
                    İzle
                  </a>

                </div>
              </div>
            ) : kaynak.type === 'book' ? (
              <div className="flex flex-col items-center sm:items-start">

                <h3 className="text-lg font-semibold text-green-900  mb-2 text-center sm:text-left">
                  {kaynak.title}
                </h3>
                <p className="text-sm text-gray-600 text-left sm:text-left">
                  {kaynak.description}
                </p>
                {kaynak.author && (
                  <p className="text-gray-500 mb-2 text-left sm:text-left">
                    Yazar: {kaynak.author}
                  </p>
                )}
              </div>
            ) : kaynak.type === 'Makale' ? (
              <div className="flex flex-col items-center sm:items-start">
                <h3 className="text-lg font-semibold text-gary-900 mb-2 text-center sm:text-left">
                  {kaynak.title}
                </h3>
                <p className="text-sm text-gray-600 mb-2 text-center sm:text-left">
                  {kaynak.description}
                </p>

              </div>
            ) : (
              <div className="flex flex-col items-center sm:items-start">
                <img
                  src={kaynak.image}
                  alt="Other content icon"
                  className="w-12 h-12 mb-4"
                />
                <h3 className="text-lg font-semibold text-gray-700 mb-2 text-center sm:text-left">
                  {kaynak.title}
                </h3>
                <a
                  href={kaynak.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-gray-800 transition text-sm text-center sm:text-left"
                >
                  Diğer İçeriğe Git
                </a>
              </div>
            )}
          </div>
        ))}
      </div>

      <div>
        {error ? (
          <p>{error}</p>
        ) : (
          <ul>
            {filteredKaynaklar.map((item, index) => (
              <li key={index}>{item.name}</li>
            ))}
          </ul>
        )}
      </div>
      {totalPages > 1 && (
        <div className="flex justify-center mt-10 overflow-x-auto">
          <div className="flex space-x-2 px-4">
            {/* First Page */}
            <button
              onClick={() => handlePageChange(1)}
              className={`px-3 py-1 sm:px-4 sm:py-2 rounded ${currentPage === 1 ? 'bg-blue-600 text-white' : 'bg-gray-300 text-gray-700'
                } hover:bg-blue-700 transition`}
            >
              1
            </button>

            {/* Show pages around the current page */}
            {currentPage > 3 && <span className="px-3 py-1">...</span>}
            {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
              .filter(page => page > 1 && page < totalPages)
              .map(page => (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  className={`px-3 py-1 sm:px-4 sm:py-2 rounded ${currentPage === page ? 'bg-blue-600 text-white' : 'bg-gray-300 text-gray-700'
                    } hover:bg-blue-700 transition`}
                >
                  {page}
                </button>
              ))
            }
            {currentPage < totalPages - 2 && <span className="px-3 py-1">...</span>}

            {/* Last Page */}
            {totalPages > 1 && (
              <button
                onClick={() => handlePageChange(totalPages)}
                className={`px-3 py-1 sm:px-4 sm:py-2 rounded ${currentPage === totalPages ? 'bg-blue-600 text-white' : 'bg-gray-300 text-gray-700'
                  } hover:bg-blue-700 transition`}
              >
                {totalPages}
              </button>
            )}
          </div>
        </div>
      )}

    </div>
  );
}
